import { InteractionType } from "@/common/types";

export interface InteractionMenuProps {
	incomingTypes: InteractionType[];
	searchText: string;
	onTypeFilterChange?: (interactions: InteractionType[]) => void;
	onQueueFilterChange: (queueIds: string[]) => void;
	onSearchChange: (text: string) => void;

	className?: string;
}

export const outboundInteractions: InteractionType[] = [
	InteractionType.Call,
	InteractionType.Email,
];

export const allInteractions: InteractionType[] = Object.keys(InteractionType)
	.map(Number)
	.filter((key: number) => !isNaN(key))
	.map((x: number) => x as InteractionType);
